module.exports = __webpack_public_path__ + "img/skill-overlays.d4840494.png";